import { create } from 'zustand';

// حالة نوافذ الشفت على مستوى التطبيق — تُفتح من الشريط العلوي، ومن بوابة
// «لا يوجد شفت»، ومن أي طلب يرفضه الخادم برمز NO_OPEN_SHIFT.
// ملف مستقل حتى يستورده api.js دون حلقة استيراد مع useShift.js.
export const useShiftUI = create((set) => ({
  modal: null, // 'open' | 'close' | 'report'
  reportShiftId: null,
  closeShiftId: null,
  openModal: (modal, extra = {}) => set({ modal, ...extra }),
  closeModal: () => set({ modal: null, reportShiftId: null, closeShiftId: null })
}));
